export default __webpack_public_path__ + "static/contract-32f382c9975ccffb38403fed1a1f37f3.png";